import { useGlobalConfig } from '../hooks/useGlobalConfig';

/**
 * Converts Unix epoch seconds to a Date object, taking into account timezone offset and global time offset.
 * @param {number} epochSeconds - Unix timestamp in seconds
 * @returns {Date} Date object adjusted for timezone and global offset
 * @example
 * dateFromEpoch(1646092800) // returns Date object for '2022-03-01T00:00:00.000Z'
 */
export const dateFromEpoch = (epochSeconds: number): Date => {
    const { $timeOffset } = useGlobalConfig();
    const today = new Date();
    const timeZoneDate = new Date((epochSeconds + today.getTimezoneOffset() * 60 + $timeOffset * 60) * 1000);

    return timeZoneDate;
};
